import PropTypes from 'prop-types';
import { Box, Skeleton, Typography, Tooltip } from '@mui/material';

const severityConfig = {
	critical: {
		label: 'Critical',
		color: 'signal.red',
	},
	warning: {
		label: 'Warning',
		color: 'signal.amber',
	},
	info: {
		label: 'Info',
		color: 'signal.blue',
	},
};

const SubscriptionSeverityBar = ({
	warning = 0,
	critical = 0,
	info = 0,
	loading,
}) => {
	const total = warning + critical + info;

	const alertLevels = Object.entries({
		critical,
		warning,
		info,
	}).map(([priority, count]) => ({
		priority,
		count,
		percentage: total > 0 ? (count / total) * 100 : 0,
		...severityConfig[priority],
	}));

	return (
		<Box>
			{loading && (
				<Skeleton
					variant='rounded'
					height={10}
					sx={{ width: '100%', borderRadius: 999, transform: 'none' }}
				/>
			)}

			{!loading && total > 0 && (
				<Box
					role='img'
					aria-label={alertLevels
						.map(
							({ label, percentage }) => `${label}: ${Number(percentage.toFixed(2))}%`
						)
						.join(', ')}
					sx={{
						display: 'flex',
						width: '100%',
						height: 10,
						overflow: 'hidden',
						borderRadius: 999,
						backgroundColor: 'action.disabledBackground',
						opacity: 1,
					}}
				>
					{alertLevels.map(
						({ priority, percentage, color, label }) =>
							percentage > 0 && (
								<Tooltip
									key={priority}
									arrow // adds arrow to tooltip
									title={`${label}: ${Number(percentage.toFixed(2))}%`}
								>
									<Box
										sx={{
											width: `${percentage}%`,
											backgroundColor: color,
											transition: 'width 300ms ease',
											cursor: 'pointer',
											'&:hover': {
												opacity: 0.8,
											},
										}}
									/>
								</Tooltip>
							)
					)}
				</Box>
			)}

			{!loading && total === 0 && (
				<Box
					sx={{
						display: 'flex',
						width: '100%',
						overflow: 'hidden',
						opacity: 1,
					}}
				>
					<Typography sx={{ color: 'text.secondary' }}>______</Typography>
				</Box>
			)}
		</Box>
	);
};

SubscriptionSeverityBar.propTypes = {
	critical: PropTypes.number,
	warning: PropTypes.number,
	info: PropTypes.number,
	loading: PropTypes.bool,
};

export default SubscriptionSeverityBar;
